import { render, staticRenderFns } from "./DictionaryReferenceDialog.vue?vue&type=template&id=6e7f0166&scoped=true&"
import script from "./DictionaryReferenceDialog.vue?vue&type=script&lang=js&"
export * from "./DictionaryReferenceDialog.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryReferenceDialog.vue?vue&type=style&index=0&id=6e7f0166&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7f0166",
  null
  
)

export default component.exports